import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { setConsentAdult } from 'services';

import { ISetConsentAdultResponse } from 'types';

type SetConsentAdultFunction = UseMutateAsyncFunction<
  ISetConsentAdultResponse,
  IError,
  void
>;

type UseSetConsentAdult = [SetConsentAdultFunction, IQueryHookOptions];

export const useSetConsentAdult = (id = ''): UseSetConsentAdult => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    ISetConsentAdultResponse,
    IError,
    void
  >(() => setConsentAdult(id));

  return [mutateAsync, { error, isError, isLoading }];
};
